export default {"src":"/_next/static/media/light-mode.ecd117cf.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};